import React, { Component } from 'react';
import { Link } from 'react-router-dom';

require('./botcatalog.css');

var pics = require('../Firebase/TinqerPics');


class SingleBotcard extends Component {

    render() {

        const { appName, appType, /*appDbLink, appStorageLink, appUserEmail, counter*/ } = this.props;
        return (
            <div className="col-md-4">
                <div className="card botCard">
                    <img className='card-img-top' id='bot_img_catalog' src={pics.tinqerGradientLogo} alt='bot_name_catalog' />
                    <div className='card-body'>
                        <span className="badge badge-primary"> {appType} <br />
                            {//<i className="fab fa-facebook-messenger"></i> 
                            }
                        </span>
                        <h4 id='bot_title_card'>{appName}</h4>
                        {/*<p id='bot_information_card'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est est
                        </p>*/}
                    </div>
                    <Link className='text-center' id='appPageLink' to={`/catalog/${appName}`}>
                        View Info
                </Link>
                </div>
            </div>
        );
    }
}

export default SingleBotcard;


// WEBPACK FOOTER //
// ./src/BotCatalog/SingleBotcard.js